import Vue from 'vue'
import Vuex from 'vuex'
import sesion from './sesion.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    sesion
  }
})
